"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountRest = function () {
  function AccountRest($http) {
    (0, _classCallCheck3.default)(this, AccountRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      ACCOUNTS_DETAIL: 'accounts/%1$s/'
    };
  }

  (0, _createClass3.default)(AccountRest, [{
    key: "update",
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.ACCOUNTS_DETAIL, id), postData);
    }
  }, {
    key: "read",
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.ACCOUNTS_DETAIL, id));
    }
  }]);
  return AccountRest;
}();

exports.default = AccountRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/AccountResource.js
// module id = 306
// module chunks = 0